import styled from "styled-components";

export const Container = styled.div``;

export const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.dimensions.spacing['1']};
  align-items: center;
  justify-content: flex-end;
`;